module.exports = __webpack_public_path__ + "static/media/2.274254a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/work/2.png
// module id = 35
// module chunks = 0